import { wrapMethodsWithLogging } from "../../components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "./BaseApiRepository";

const SourceApiRepository = {

    async getWhoAmIAsync() {
        return await BaseApiRepository.getAsync(`source/who-am-i`);
    },

    async getPositionAsync(obj) {
        return await BaseApiRepository.postAsync('source/position/location-name', { longitude: obj.lng, latitude: obj.lat });
    },

    async getPilotStationsAsync() {
        return await BaseApiRepository.getAsync("source/pilot-stations");
    },

    async getConfigAsync() {
        return await BaseApiRepository.getAsync('source/config');
    },

    async getAiConnectionStringAsync() {
        return await BaseApiRepository.getAsync('source/connection-string/ai');
    },

    async getPilotagePilotTypesAsync() {
        return await BaseApiRepository.getAsync('source/pilotage-pilot/types');
    },

    async getShipPositionsAsync(shipIds) {
        return await BaseApiRepository.postAsync('source/ship-position', shipIds)
    },

    async getShipPositionsWithinAreaAsync(latitude, longitude, width, height) {
        return await BaseApiRepository.getAsync(`source/ship-position/area?latitude=${latitude}&longitude=${longitude}&width=${width}&height=${height}`)
    },

    async getShipPositionsByNameAsync(name) {
        return await BaseApiRepository.getAsync(`source/ship-position/name?name=${name}`)
    },

    async searchPersonsAsync(query) {
        return await BaseApiRepository.postAsync('source/users/search', query)
    },

    async getPersonByIdAsync(id) {
        return await BaseApiRepository.getAsync(`source/user/${id}`)
    },

    async getImpersonateTokenByPersonIdAsync(id) {
        return await BaseApiRepository.getAsync(`source/user/${id}/impersonate`)
    },

    async stopImpersonateTokenByPersonIdAsync(id) {
        return await BaseApiRepository.getAsync(`source/user/${id}/impersonate/stop`)
    },

    async getPersonTypesAsync() {
        return await BaseApiRepository.getAsync('source/types/person');
    },

    async getAllPersonTypesAsync() {
        return await BaseApiRepository.getAsync('source/types/person/all');
    },

    async searchShipsAsync(query) {
        return await BaseApiRepository.postAsync(`incident/search/ships`, query);
    },

    async getPilotOfficesAsync() {
        return await BaseApiRepository.getAsync('source/pilot-offices');
    },

    async getPilotOfficesPilotStationsAsync() {
        return await BaseApiRepository.getAsync('source/pilot-offices/pilot-stations');
    },

    async getPilotOfficesPilotStationsPilotsAsync(pilotStationIds) {
        return await BaseApiRepository.postAsync('source/pilot-offices/pilot-stations/pilots', pilotStationIds);
    },

    async getShiftPlanPeriodTypesAsync() {
        return await BaseApiRepository.getAsync('source/types/shift-plan-period');
    },
};
wrapMethodsWithLogging(SourceApiRepository);

export default SourceApiRepository;
